import { SB } from '@play-co/replicant';

const treasureExpressEntry = SB.object({
  /** Tickets the user has obtained */
  tickets: SB.number(),

  /** Milestones user has claimed */
  claimedMilestones: SB.number(),

  /** Users difficulty for the event */
  difficulty: SB.string(),
});

export type TreasureExpressEntry = SB.ExtractType<typeof treasureExpressEntry>;

export const treasureExpressSchema = {
  treasureExpress: SB.object({
    /** Map of events that user has participated in */
    entries: SB.map(treasureExpressEntry),
    /** Last time user has seen the treasure express */
    lastSeenAt: SB.int().optional(),
  }),
};
